/** PrivacyPolicy — legal document rendered from the shared `legal.privacyPolicy` copy. */
import { ShieldIcon } from '../components/ui/icons';
import { LegalContent, type LegalSectionConfig } from '../features/support/LegalContent';

const PRIVACY_SECTIONS: readonly LegalSectionConfig[] = [
  { key: 'plainEnglish' },
  { key: 'informationCollected' },
  { key: 'ipCookiesGifs' },
  { key: 'howInfoUsed' },
  { key: 'operationalProviders' },
  { key: 'advertisersSponsors' },
  { key: 'disclosingInfo' },
  { key: 'limitations' },
  { key: 'deleteData' },
  { key: 'updates' },
];

export function PrivacyPolicy() {
  return (
    <LegalContent contentKey="privacyPolicy" sections={PRIVACY_SECTIONS} heroIcon={ShieldIcon} />
  );
}
